export function getStoredUserInfo() {
  try {
    const raw = localStorage.getItem("userInfo");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isValidSettingsTab(key, tabs) {
  if (!key || !Array.isArray(tabs)) return false;
  return tabs.some((tab) => tab.key === key);
}

export function groupTabsByCategory(tabs) {
  return tabs.reduce((acc, tab) => {
    const group = tab.group || "Autres";

    if (!acc[group]) acc[group] = [];

    acc[group].push(tab);

    return acc;
  }, {});
}

export function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function filterSettingsTabs(tabs, query) {
  const q = normalizeText(query);

  if (!q) return tabs;

  return tabs.filter((tab) => {
    return normalizeText(
      `${tab.label || ""} ${tab.group || ""} ${tab.description || ""}`
    ).includes(q);
  });
}